<template>
  <v-container>

    <v-row no-gutters>
      <v-col
        md="8"
        offset-md="2"
      >

        <v-card
          rounded
          min-height='900px'
          elevation="8"
        >

          <v-form
            class='pa-8'
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <h2>Donation Form</h2>
            <v-text-field
              outlined
              v-model="fname"
              :rules="generalRules"
              label="First Name"
              required
            ></v-text-field>
            <v-text-field
              outlined
              v-model="lname"
              :rules="generalRules"
              label="Last Name"
              required
            ></v-text-field>
            <v-text-field
              outlined
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>

            <h2>Donation Details</h2>

            <v-select
              outlined
              v-model="isFunctionalAnd7YearsOld"
              :items="yesNoOnly"
              @change='functionOption()'
              :rules="generalRules"
              label="Are all devices functional and less than 7 years old?"
              required
            ></v-select>
            <v-alert
              style="margin-top : -23px"
              dense
              type="info"
              outlined
            >
              Only functional laptops and phones are accepted for donation. If you are donating an iPhone, remember to sign out of icloud. If you are donating a google phone, remove your google account.
            </v-alert>
            <v-text-field
              outlined
              v-model="computerToDonate"
              :rules="numberOnlyRules"
              label="How many reusable items will you donate?"
              required
            ></v-text-field>
            <v-alert
              style="margin-top : -23px"
              dense
              type="info"
              outlined
            >
              Device Passports will be created for each reusable device.
            </v-alert>
            <v-textarea
              v-model="describe"
              outlined
              name="input-7-4"
              label="Describe the Donation"
            ></v-textarea>

            <h2>Mailing Address <br /> (Continental U.S. only, no Hawaii or Alaska)
            </h2>

            <v-text-field
              outlined
              v-model="address"
              :rules="generalRules"
              label="Address"
              required
            ></v-text-field>

            <v-text-field
              outlined
              v-model="address2"
              label="Address 2"
            ></v-text-field>
            <v-text-field
              outlined
              v-model="city"
              :rules="generalRules"
              label="City"
              required
            ></v-text-field>
            <v-select
              outlined
              v-model="state"
              :items="stateList"
              :rules="generalRules"
              label="State"
              required
            ></v-select>
            <v-text-field
              outlined
              v-model="zip"
              :rules="zipRules"
              label="Zip"
              required
            ></v-text-field>



            <v-btn
              v-if='showButton'
              :disabled="!valid"
              color="success"
              class="mr-4"
              :loading='submitLoading'
              @click="validate"
            >
              Submit
            </v-btn>

          </v-form>

        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      transition="scale-transition"
      v-model="completeDialog"
      max-width="310"
    >
      <v-card>
        <v-card-title class="headline">
          Thank you.&#128151;
        </v-card-title>
        <v-card-text class="subtitle-1">Thank you for offering to donate. Your offer will get reviewed and then you'll receive a follow-up email with donation instructions. Expect a response in less than 24 hours.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="completeDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-dialog
      transition="fade-transition"
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Thank you!&#128151;
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-card-text
              v-if='OldcomputerContent'
              class="title"
            >
              Sorry, we only accept reusable items. Review the reuse criteria <a
                href='https://ecycleforgood.com/index.php/donation-guide/'
                target='blank'
              >here</a>. To find a certified electronics recycler near you click <a
                href='https://sustainableelectronics.org/recyclers'
                target='blank'
              >here</a>
            </v-card-text>

            <v-card-text
              v-else
              class="title"
            >
              Sorry, we only accept computers functional computers. Your best option
              is to recycle your computer locally at a certified electronics recycling
              company.
            </v-card-text>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog3"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline">
          {{donationList.length > 0 ? "Select donation" : "No donation record found."}}
        </v-card-title>
        <v-card-text>
          <v-simple-table
            fixed-header
            height="500px"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Donation Time
                  </th>
                  <th class="text-left">
                    Computers Donated
                  </th>
                  <th class="text-left">
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style='cursor: pointer;'
                  @click='changeRoute(item.id)'
                  v-for="item in donationList"
                  :key="item.time"
                >
                  <td>{{ item.time }}</td>
                  <td>{{ item.computerToDonate }}</td>
                  <td>{{ item.description }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="landingDialog"
      max-width="390"
    >
      <v-card>
        <v-toolbar
          class='toolbarTitle'
          height="100px"
          dark
          extended
          flat
        >

        </v-toolbar>
        <v-card-text style="margin-top: -64px;">
          <v-row>

            <v-col cols='12'>
              <v-card
                outlined
                class="headline text-center justify-center py-6"
                min-height='30px'
              >

                <div>

                  <p class='title'>Search Past Donations</p>

                  <v-form
                    class='pa-5'
                    ref="form2"
                    v-model="Form2valid"
                    lazy-validation
                  >

                    <v-text-field
                      v-model="existingEmail"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="existingZip"
                      :rules="zipRules"
                      label="Zip Code"
                      required
                    ></v-text-field>
                    <v-btn
                      rounded
                      :disabled="!valid"
                      color="success"
                      class="mr-4"
                      @click="validate2"
                      :loading='searchLoading'
                    >
                      Search
                    </v-btn>
                  </v-form>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    company: Object,
  },
  data: () => ({
    fname: "",
    lname: "",
    showButton: true,
    submitLoading: false,
    searchLoading: false,
    donationList: [],
    dialog3: false,
    stateList: [
      "AK",
      "AR",
      "AS",
      "AZ",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "GU",
      "IA",
      "ID",
      "IL",
      "IN",
      "KS",
      "KY",
      "LA",
      "MA",
      "MD",
      "ME",
      "MI",
      "MN",
      "MO",
      "MS",
      "MT",
      "NC",
      "ND",
      "NE",
      "NH",
      "NJ",
      "NM",
      "NV",
      "NY",
      "OH",
      "OK",
      "OR",
      "PA",
      "PR",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VA",
      "VI",
      "VT",
      "WA",
      "WI",
      "WV",
      "WY",
    ],
    existingEmail: "",
    existingZip: "",
    OldcomputerContent: false,
    Form2valid: true,
    initSection: true,
    landingDialog: false,
    completeDialog: false,
    response: false,
    dialog: false,
    yesNoOnly: ["Yes", "No"],
    yesNo: ["Yes", "No", "N/A"],
    describe: undefined,
    computerToDonate: undefined,
    valid: true,
    isFunctionalAnd7YearsOld: undefined,
    computerAge7orless: undefined,
    phoneTableAge5orless: undefined,
    name: "",
    generalRules: [(v) => !!v || "this field is required"],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    address: "",
    address2: "",
    city: "",
    state: "",
    zip: undefined,
    zipRules: [
      (v) => !!v || "this field is required",
      (v) => /^\d{5}?$/.test(v) || "zip code must be valid eg: 44240",
    ],
    numberOnlyRules: [
      (v) => !!v || "this field is required",
      (v) => /^[0-9]+$/.test(v) || "please enter numbers only",
    ],
    checkbox: false,
  }),

  methods: {
    getImg() {
      return (
        "https://storage.googleapis.com/donorconnection-df169.appspot.com/logos/" +
        this.$route.params.company +
        ".png"
      );
    },
    changeRoute(id) {
      this.$router.push({ path: "/mydonation/" + id });
    },
    viewExistDonation() {
      this.initSection = false;
    },
    async graphqlMutation(data, callback) {
      await this.$axios
        .post(
          "https://us-central1-donorconnection-df169.cloudfunctions.net/api/gql",
          {
            query: data,
          }
        )
        .then((response) => {
          return callback(response);
        })
        .catch((error) => {
          return callback(error.response);
        });
    },
    onVerify: function () {
      this.response = true;
    },

    functionOption() {
      if (this.isFunctionalAnd7YearsOld === "No") {
        this.dialog = true;
        this.OldcomputerContent = false;
        this.showButton = false;
      } else {
        this.showButton = true;
      }
    },
    validate2() {
      var v = this.$refs.form2.validate();
      if (v === false) {
        return;
      } else {
        this.searchLoading = true;
        // do some post req
        this.graphqlMutation(
          `query{searchDonation(email:"${this.existingEmail.toLowerCase()}",zip:"${
            this.existingZip
          }",npoID:"${
            this.$route.params.company
          }"){id,time,description,computerToDonate}}`,
          (res) => {
            if (res.data.data.searchDonation) {
              this.donationList = res.data.data.searchDonation;
            }
            this.dialog3 = true;
            this.searchLoading = false;
          }
        );
      }
    },
    async validate() {
      this.submitLoading = true;
      var v = this.$refs.form.validate();
      if (v === false) {
        this.submitLoading = false;
        return;
      } else {
        try {
          const recaptchaToken = await new Promise((resolve, reject) => {
            window.grecaptcha.ready(async () => {
              try {
                const token = await window.grecaptcha.execute('6LdkQvIsAAAAAGRe8sM29xhLq8_Lm343cHnP4P-x', {action: 'submit'});
                resolve(token);
              } catch (e) {
                reject(e);
              }
            });
          });

          await axios.post('https://us-central1-donorconnection-df169.cloudfunctions.net/api/addDonationRecord', {
               name : this.fname + " " + this.lname,
               email: this.email,
               address:this.address,
               address2:this.address2,
               city: this.city,
               state:this.state,
               zip:this.zip,
               refurbisher:this.$route.params.refurbisher,
               computerToDonate:this.computerToDonate,
               isFunctionalAnd7YearsOld:this.isFunctionalAnd7YearsOld,
               description: this.describe,
               ngo : this.$route.params.company,
               recaptchaToken: recaptchaToken
            }, { headers: { "Content-Type": "application/json" } })

          this.submitLoading = false;
          this.completeDialog = true;
          this.$refs.form.reset();
        } catch (error) {
          console.error("reCAPTCHA/Submit error:", error);
          this.submitLoading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.toolbarTitle {
  background: rgb(34, 193, 195);
  background: linear-gradient(
    22deg,
    rgba(34, 193, 195, 1) 0%,
    rgba(67, 222, 101, 1) 100%
  );
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>